import { combineReducers } from 'redux'

import data from './data/slice'

const editReducer = combineReducers({
  data,
})

export default editReducer
